// extracted by mini-css-extract-plugin
module.exports = {"image-container":"ResponsiveImage_image-container__1dn3S","image":"ResponsiveImage_image__K_qtD","gift-banner":"ResponsiveImage_gift-banner___B3PN"};